export default function initParallax() {
    document
        .querySelectorAll("[data-parallax] img, [data-parallax] video")
        .forEach((element) => {
            element.setAttribute("data-speed", "auto");
        });
}
